module.exports = __webpack_public_path__ + "static/img/ukbta.6349293.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ticker/ukbta.png
// module id = aTKH
// module chunks = 0